<template>
  <div>


        <button class="p-button p-component p-button-help exportBtn" type="button" @click.prevent="exportCSV()">
          <span class="pi pi-upload p-button-icon p-button-icon-left"></span><span class="p-button-label">Export</span>
          <span class="p-ink"></span>
        </button>
    
      <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-12 p-col-12">
    <DataTable
      :value="itemMasterLists"
      :paginator="true" ref="po"
      :rows="100" :filters="filters" :lazy="false"
      :rowsPerPageOptions="[100,500,1000]"
      :loading="loading"
      class="p-datatable-responsive p-datatable-gridlines"
      :resizableColumns="true" columnResizeMode="fit"
    >
        <Column header="S.N" >
          <template #body="slotProps">
             {{slotProps.index+1}}
          </template>
        </Column>
      <Column header="Group" field="groupName" :sortable="true"  filterMatchMode="contains">
      <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['groupName']" />
        </template>
      </Column>
      <Column header="Sub Group"  field="subGroupName" :sortable="true"
        filterMatchMode="contains">
        <template #body="slotProps">
          {{slotProps.data.subGroupName == 'N/A'?' ':slotProps.data.subGroupName}}
        </template>
        <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['subGroupName']" />
        </template>
      </Column>
      <Column headerStyle="width: 16em" header="Name" field="name" :sortable="true"  filterMatchMode="contains">
       <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['name']" />
        </template>
      </Column>
      <Column header="Code" field="itemCode" :sortable="true"  filterMatchMode="contains" >
       <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['itemCode']" />
        </template>
      </Column>
      <Column header="Opn Stock" field="openingStock" :sortable="true" filterMatchMode="contains" >
       <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['openingStock']" />
        </template>
      </Column>
      <Column header="Unit"  field="unitName" :sortable="true" filterMatchMode="contains">
       <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['unitName']" />
        </template>
      </Column>
      <Column header="Status"  field="status" :sortable="true" filterMatchMode="contains">
       <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['status']" />
        </template>
      </Column>
      <Column header="Hs Code"  field="hsCode" :sortable="true" filterMatchMode="contains">
       <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['hsCode']" />
        </template>
      </Column>
      <template #empty>No record found</template>
      <Column header="Action" headerStyle="width: 15em" >
        <template #body="slotProps">
          <Button class="p-button-raised p-button-info" @click="viewImage(slotProps.data.imageList)" icon="pi pi-image"/>
          <!-- <a href="#" @click.prevent="viewQr(slotProps.data)"><img src="../../../../static/img/qr.png" style="height:40px;width:40px;"/></a> -->
          <Button class="p-button-raised p-button-success" icon="pi pi-pencil" @click="editItemMaster (slotProps.data)"/>
          <Button class="p-button-raised p-button-success" icon="pi pi-eye" @click="viewItemMaster (slotProps.data)"/>
          <Button class="p-button-raised p-button-danger" v-if="!slotProps.data.systemOnly"  @click="openDialog(slotProps.data.id)" icon="pi pi-trash"/>
          <Button class="p-button-raised p-button-danger" icon="pi pi-trash" v-else @click="openDialog(slotProps.data.id)" disabled/>
        </template>
        </Column>
    </DataTable>
        </div>
   </div>
    <Dialogs header="View Image " :modal="true"
      :visible.sync="imageDialog" :style="{width: '50vw'}">
      <div>
        <Carousel :value="images">
          <template #item="slotProps">
            <!-- {{slotProps.data.name}} -->
            <div class="product-item">
              <div class="product-item-content">
               <div class="p-mb-3">
                   <img :src="slotProps.data.name"  style="height:250px;width:250px" class="product-image" />
               </div>
             </div>
           </div>
	        </template>
        </Carousel>
      </div>
    </Dialogs>
    <Dialog v-model="dialogShow" @cancel="cancel" @deleted="deleteItemMaster"/>
     <!-- </div> -->
  </div>
</template>
<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dialog from '../../layout/dialog'
import globalKey from '../../../store/globalKey'
import axios from 'axios'
import Dialogs from 'primevue/dialog'
import InputText from 'primevue/inputtext'
import Carousel from 'primevue/carousel'
import Button from 'primevue/button'
export default {
  name: 'itemMasterList',
  data () {
    return {
      dialogShow: false,
      itemId: '',
      loading: false,
      imageDialog: false,
      filters: {},
      index: 0,
      images: null
    }
  },
  computed: {
    itemMasterLists() {
      return this.$store.state.itemMaster.itemMasterLists
    }
  },
  mounted() {
    this.itemMasterList()
    this.columnNames()
    // this.onLazyEvent()
  },
  methods: {
    async itemMasterList() {
      await this.$store.dispatch('loadItemMasterList')
    },
    async deleteItemMaster(value) {
      if (value.trim() === '') {
        let message = {
          message: 'Delete Reason cannot be empty.',
          messageType: 'error'
        }
        this.$emit('delete-message', message)
        this.dialogShow = true
        return
      }
      let deleteRe = {
        itemId: this.itemId,
        deleteReason: value
      }
      let resp = await this.$store.dispatch('deleteItemMaster', deleteRe)
      if (resp.data.status === 'SUCCESS') {
        let message = {
          message: resp.data.message,
          messageType: 'success'
        }
        this.$emit('delete-message', message)
      } else {
        let message = {
          message: resp.data.message,
          messageType: 'warn'
        }
        this.$emit('delete-message', message)
      }
      this.closeDialog()
    },
    editItemMaster(data) {
      this.$emit('edit-item', data)
    },
    viewItemMaster(data) {
      this.$emit('view-item', data)
    },
    viewImage(imageList) {
      this.images = imageList
      this.imageDialog = true
    },
    viewQr(data) {
      this.$router.push({name: 'Qrcode', params: { qrData: data }})
    },
    exportCSV() {
      let data = {
        columnList: this.columnList
      }
      axios({
        url: globalKey + '/fileDownload/excelReportAccount/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/Item List' + '/' + this.$store.getters.fyId + '/' + data.columnList,
        method: 'get',
        headers: { 'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token },
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'itemList.xlsx'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    columnNames() {
      for (let i = 0; i < this.$refs.po.columns.length; i++) {
        this.columnList += this.$refs.po.columns[i].header + ','
      }
    },
    openDialog(id) {
      this.dialogShow = true
      this.itemId = id
    },
    closeDialog() {
      this.dialogShow = false
      this.deleteReason = ''
    },
    cancel(data) {
      this.dialogShow = false
    }
  },
  components: {
    DataTable,
    Column,
    Dialog,
    InputText,
    Dialogs,
    Carousel,
    Button
  }
}
</script>

<style>
.p-datatable table {
  border-collapse: collapse;
  width: 100%;
  table-layout: auto;
  column-gap: inherit;
}
._message {
  width: fit-content;
  float: right;
  margin-top: -2%;
  margin-right: 1%;
}
.overlay {
  position: fixed;
  display: none;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  cursor: pointer;
}
.loadingImg {
  margin:auto;
  position:absolute;
  left:0;
  right:0;
}.product-item {
    .product-item-content {
        border: 1px solid var(--surface-d);
        border-radius: 3px;
        margin: .3rem;
        text-align: center;
        padding: 2rem 0;
    } .product-image {
        width: 50%;
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23)
    }
}
</style>



// WEBPACK FOOTER //
// itemMasterList.vue?03d253de